module.exports = __webpack_public_path__ + "93a7363df2524940d8b45b313925e4ff.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/medieval-tower.png
// module id = 2841
// module chunks = 0